"use client";

import { ProductCard } from "@/components/ui/ProductCard/productCard";
import PaginationControls from "@/components/ui/pagination";
import { Product } from "@/lib/models/product";

interface ProductsClientProps {
  products: Product[];
  total: number;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
  loadingPrices?: boolean;
}

export function ProductsClient({
  products,
  total,
  currentPage,
  pageSize,
  isLoading,
  onPageChange,
  loadingPrices,
}: ProductsClientProps) {
  const totalPages = Math.ceil(total / pageSize);
  // El orden por precio ya se aplica en ProductsPageClient.filterByPrice()
  // (con el precio real ya calculado por cliente), así que aquí solo se
  // muestran los productos en el orden en que llegan.
  const sortedProducts = products;
  if (sortedProducts.length === 0) {
    if (isLoading) {
      return (
        <div className="flex items-center justify-center min-h-96">
          <p className="text-muted-foreground">Buscando productos...</p>
        </div>
      );
    }
    return (
      <div className="flex items-center justify-center min-h-96">
        <p className="text-muted-foreground">No se encontraron productos</p>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {!loadingPrices &&
            sortedProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                loadingPrices={loadingPrices}
              />
            ))}
        </div>
        {totalPages > 1 && (
          <div className="flex items-center justify-end mt-4">
            <div>
              <PaginationControls
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={(p) => {
                  onPageChange(p);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
